import { HTMLAttributes, ReactNode } from "react";

export type RowProps = {
  gutter?: Partial<Record<RowMedia, RowBaseGutter>> | RowBaseGutter; // 间距

  // wrap?: boolean; // 是否自动换行
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export type RowBaseGutter = number | [number, number];

// 目前只支持 md，用于区分 m 和 pc
export enum RowMedia {
  xxs = "xxs", // >= 0 & < 576
  xs = "xs", // >= 576
  md = "md", // >= 768
  // lg = "lg", // >= 992
  // xl = "xl", // >= 1200
  // xxl = "xxl", // >=1600
}
